<template>
  <v-dialog max-width="400px" :value="value" @input="toggleModal()">
    <v-card class="error">
      <v-card-text>
        <v-row>
          <v-col class="text-center py-3" cols="12" >
            <v-icon color="white" size="50">warning</v-icon>
          </v-col>
          <v-col cols="12" class="white--text text-center">
            <h4>
              ¿En verdad quieres eliminar este dato adicional?
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="white"
               outlined
               text
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn color="white"
               @click="submit()"
               :loading="extraDataDeleteLoading">
          {{ $t('general.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectedJourney: state => state.journey.selectedJourney
    })
  },
  data: () => ({
    extraDataDeleteLoading: false
  }),
  methods: {
    async submit () {
      if (this.extraDataDeleteLoading) return
      const { extradata, ...all } = this.selectedJourney
      try {
        this.extraDataDeleteLoading = true
        const indexToDelete = extradata.map(item => item.id).indexOf(this.selectedExtraData.id)
        if (indexToDelete === -1) return notifications.error('No se ha encontrado el extraData seleccionado')
        extradata.splice(indexToDelete, 1)
        const data = { extradata, replaceVal: false, ...all }
        await this.$store.dispatch('updateJourney', { journeyId: this.$route.params.journeyId, data })
        await this.$store.dispatch('getJourney', {
          companyId: this.$route.params.companyid,
          appId: this.$route.params.appid,
          journeyId: this.$route.params.journeyId
        })
        this.extraDataDeleteLoading = false
        notifications.success('Extra data eliminado correctamente')
        this.toggleModal()
      } catch (e) {
        this.extraDataDeleteLoading = false
        console.error(e)
        throw e
      }
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    value: {
      type: Boolean
    },
    selectedExtraData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
